var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisabledAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0779 3.00136C11.2368 2.84241 11.4255 2.71632 11.6332 2.6303C11.8409 2.54428 12.0635 2.5 12.2883 2.5C12.513 2.5 12.7356 2.54428 12.9433 2.6303C13.151 2.71632 13.3397 2.84241 13.4986 3.00136C13.6576 3.16031 13.7837 3.34901 13.8697 3.55669C13.9557 3.76436 14 3.98695 14 4.21174C14 4.43653 13.9557 4.65912 13.8697 4.8668C13.7837 5.07447 13.6576 5.26317 13.4986 5.42212L5.32855 13.5922L2 14.5L2.90779 11.1714L11.0779 3.00136Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5.31653,
    width: 4,
    height: 15,
    transform: "rotate(-45 2 5.31653)",
    fill: "#A4A8B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4.49988L12 12.4999",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledAi);
export default __webpack_public_path__ + "static/media/disabled-ai.d40fde60.svg";
export { ForwardRef as ReactComponent };